import React from 'react'
import styled from 'styled-components'

import logo from '../images/footer-logo.png'

const FooterComponent = styled.footer`
  background-color: white;
  display: flex;
  justify-content: center;
`

const Logo = styled.img`
  height: 2rem;
  padding: 1rem;
  width: auto;
`

function Footer() {
  return (
    <FooterComponent>
      <Logo src={logo} alt="logo" />
    </FooterComponent>
  )
}

export default Footer
